import React, { forwardRef } from 'react';

interface BookMarkFullProps {
  classes?: string;
  style?: React.CSSProperties;
}

export const BookMarkFull = forwardRef<HTMLElement, BookMarkFullProps>(({ classes, style = {} }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-bookmark ${classes || ''}`} style={style}></i>
  );
});

BookMarkFull.displayName = 'BookMarkFull';
